import { render, staticRenderFns } from "./CartItemsList.vue?vue&type=template&id=dc758b1c&scoped=true&"
import script from "./CartItemsList.vue?vue&type=script&lang=js&"
export * from "./CartItemsList.vue?vue&type=script&lang=js&"
import style0 from "./CartItemsList.vue?vue&type=style&index=0&id=dc758b1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc758b1c",
  null
  
)

export default component.exports